/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mail_Compose_SentInputs */

const en_mail_compose_sent = /** @type {(inputs: Mail_Compose_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} emails sent`)
};

const de_mail_compose_sent = /** @type {(inputs: Mail_Compose_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} E-Mails gesendet`)
};

/**
* | output |
* | --- |
* | "{count} emails sent" |
*
* @param {Mail_Compose_SentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_sent = /** @type {((inputs: Mail_Compose_SentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_SentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_sent(inputs)
	return en_mail_compose_sent(inputs)
});